module.exports = __webpack_public_path__ + "img/poi-pin.1f488872.png";